import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'for_each_additional_active_trade_union_that_is_smaller_than_the'

export const dataPointDefinition = {
  retracedId: 'for_each_additional_active_trade_union_that_is_smaller_than_the',
  name: 'For each additional active trade union that is smaller than the 5th largest unions in the facility, provide:\r\r\n• name of the union\r\r\n• name of the federation or confederation with which the union is affiliated, if applicable\r\r\n• number of total union members\r\r\n• number of female union members\r\r\n• number of total union officials \r\r\n• number of female union officials',
  meta: {},
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'foa-cb-2--4',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 12080,
  sectionId: '2.2.8',
  impactArea: 'Freedom of Association and Collective Bargaining',
  impactAreaId: 'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
